import {AddTagControlMinimalType, GetItemCounts, useInfiniteNames, useInfiniteTags} from "@twigsby/client-data";
import {
    AlertBanner,
    ColourSolid,
    ComboBoxControl, ContentBlock,
    ContentLoader,
    SelectItemType
} from "@twigsby/frontend-framework";
import React, {useEffect, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {ShapeTagSelectData} from "./TagHelpers";

interface AddTagControlMinimalFeType extends AddTagControlMinimalType {
    placeholder?: string;
    singleSelection?: boolean;
    reset?: boolean;
    onChangeItemsCallback?: (e: any) => void;
    resetSelectedCallback?: () => void;
}

const AddTagControlMinimal = (props: AddTagControlMinimalFeType) => {
    const { t } = useTranslation();
    const [tagData, setTagData] = useState<Array<SelectItemType>>([]);
    const [ itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const {
        status,
        data,
        error,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        dataUpdatedAt
    } = useInfiniteTags();

    const HandleChange = (e: Array<any>) => {
        if(props.updateCallback) {
            props.updateCallback(e);
        }
    }

    const HandleReset = () => {
        if(props.resetSelectedCallback) {
            props.resetSelectedCallback();
        }
    }

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
            setTagData(ShapeTagSelectData(data));
        }
    }, [dataUpdatedAt]);

    return (
        <>
            {status === 'loading' ? (
                <ContentLoader rounded={true} childCount={1} />
            ) : status === 'error' ? (
                <ContentBlock error={true} stacked={true} title={error.name} content={error.message} />
            ) : (
                <ComboBoxControl
                    name={props.name || 'addTagsMenu'}
                    placeholder={props.placeholder || t('controls.tagsPlaceholder')}
                    data={tagData}
                    forwardValueCallback={(e) => props.singleSelection ? HandleChange(e) : null}
                    forwardValuesCallback={(e) => HandleChange(e)}
                    forwardItemCallback={(e) => {
                        HandleChange([e.value]);
                        if(props.onChangeItemsCallback) {
                            props.onChangeItemsCallback(e);
                        }
                    }}
                    resetSelectedCallback={() => HandleReset()}
                    defaultValues={props.existingTags as Array<number>}
                    loading={isFetchingNextPage}
                    listAlwaysVisible={props.listAlwaysVisible}
                    valueType={'number'}
                    singleSelection={props.singleSelection}
                    reset={props.reset}
                    itemCounts={itemCounts}
                    hasNextPage={hasNextPage}
                    isFetchingNextPage={isFetchingNextPage}
                    fetchNextPage={fetchNextPage}
                />
            )}
        </>
    )
}

export default AddTagControlMinimal
